import React, { useContext } from "react";
import "./productStyles.css";
import DropzoneSimple from "../DropzoneSimple";
import DropzoneSVG from "../DropzoneSVG";
import background from "../assets/lfsbi.png";
import DROPZONE_DATA from "../DROPZONE_DATA";
import OpacityContext from "../OpacityContext";
import "./productStyles.css"; //* migrate styles added by js for the products to this stylesheet

export default function L_fsbi({
  handleWarningMessageText,
  handleDropzoneChanges,
  handleContinueButtonDisabled
}) {
  const { lfdFile } = useContext(OpacityContext);

  return (
    <div className="landscapeProductContainer">
      <img
        alt=""
        className="backgroundImageContainer landscape"
        src={background}
      ></img>
      {/* <div style={lFullScreen} className="lFullScreen"> */}
      <div className="landscapeFullScreen">
        <DropzoneSimple
          acceptedFileTypeString={DROPZONE_DATA.data.imageAndVideo}
          handleDropzoneChanges={handleDropzoneChanges}
          handleWarningMessageText={handleWarningMessageText}
          droppedFileType="landscape"
          assetFileToChange={lfdFile}
          handleContinueButtonDisabled={handleContinueButtonDisabled}
        />
      </div>
      <div className="lFSBISVG">
        <DropzoneSVG
          acceptedFileTypeString={DROPZONE_DATA.data.svgOnly}
          handleDropzoneChanges={handleDropzoneChanges}
          handleWarningMessageText={handleWarningMessageText}
          droppedFileType="svg"
          handleContinueButtonDisabled={handleContinueButtonDisabled}
        />
      </div>
    </div>
  );
}
